module.exports = __webpack_public_path__ + "static/media/footer-tendances.a5176a8b.png";